<div class="scv2-stepper">
  <ng-container *ngFor="let label of steps; let i = index; let last = last">
    <div class="scv2-stepper-node">
      <div class="scv2-stepper-dot" [class.scv2-active]="i <= stepIndex">
        <i *ngIf="i < stepIndex" class="pi pi-check"></i>
        <span *ngIf="i >= stepIndex">{{ i + 1 }}</span>
      </div>
      <div class="scv2-stepper-label" [class.scv2-active]="i <= stepIndex">{{ label }}</div>
    </div>
    <div *ngIf="!last" class="scv2-stepper-line" [class.scv2-active]="i < stepIndex"></div>
  </ng-container>
</div>
